/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveForwardIcon24Regular = forwardRef('TimeClockMoveForwardIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.533 3.881A8.25 8.25 0 0 1 19.35 8.25H16.5a.75.75 0 0 0 0 1.5H21a.75.75 0 0 0 .75-.75V4.246a.75.75 0 0 0-1.5 0v2.558a9.75 9.75 0 1 0 .778 8.877.75.75 0 0 0-1.389-.566A8.25 8.25 0 1 1 10.533 3.88Z" }),
        React.createElement("path", { d: "M12.5 7.313a.75.75 0 0 0-1.5 0v3.948a2.25 2.25 0 0 0 1.244 2.012l3.296 1.648a.75.75 0 1 0 .67-1.342l-3.295-1.648a.75.75 0 0 1-.415-.67V7.313Z" })));
});
